<template>
  <div>
    <div class="plan-content" id="mealInput" :class="{'spe-content':modifyAgent}">
      <!--新增单价 历史账单-->
      <div v-if="historyUnitPrices && role=='root'" class="unit-price" id="unit-price">
        <span>单价</span>
        <el-tooltip>
          <div slot="content">表示的是该分销<br/>1工号/1年/1000日查的价格</div>
          <img svg-inline src="../../assets/warning-price.svg" alt="" style='width:14px;height:14px;margin-right:10px;color: #e5e5e5'>
        </el-tooltip>
        <el-form :model="ruleForm" :rules="rules">
          <el-form-item prop="newUnitPrice">
            <el-input class="customText" v-model='ruleForm.newUnitPrice' maxlength='5'/>
          </el-form-item>
        </el-form>
        <span :class="historyUnitPrices.length>0?'history-title':'not-click-title'" @click="isShowHistoryDialog=historyUnitPrices.length>0">历史记录</span>
      </div>
      <!--标题-->
      <div v-else class="new-title">基础套餐</div>
      <!-- <el-row style="color:#555;" type="flex" :gutter="10">
        <el-col :span='comColSpan(3,4)'  class="title" style="width:125px;">套餐名称</el-col>
        <el-col :span='comColSpan(6,7)' class="title" style="border-left:none;width:180px">主/子/日查看额度</el-col>
        <el-col :span='4' class="title" style="border-left:none;width:155px;" v-if='modifyAgent'>企业公海/线索</el-col>
        <el-col :span='comColSpan(4,5)' class="title" style="border-left:none;">默认有效期</el-col>
        <el-col :span='2' class="title" style="border-left:none;">最多加子</el-col>
        <el-col :span='2' class="title" style="border-left:none;">最多加月</el-col>
        <el-col :span='2' class="title" style="border-left:none;">加日查看</el-col>
        <el-col :span='2' class="title" style="border-left:none;">单价</el-col>
        <el-col :span='2' class="title" style="border-left:none;">操作</el-col>
      </el-row>
      <el-row @click.native="clear" v-for="(item, index) in plans" :key="index" :gutter="10" class="meal-content " >
        <el-col :span="comColSpan(3,4)" style="border-right:1px solid #ddd;width: 118px;">
          <el-input style="text-align:center" v-model="plans[index].type"  :disabled="setDisable(index)" :class="checkErr(index,'type')? 'error' : ''"></el-input>
        </el-col>
        <el-col :span="comColSpan(6,7)" class="middle-content" style="width:171.5px;">
          <el-input style="width: 40px;" v-model="plans[index].mainaccounts" :disabled="true"></el-input>
          <el-input style="width: 40px;" v-model="plans[index].subaccounts" :disabled="setDisable(index)"  :class="checkErr(index,'subaccounts')? 'error' : ''"></el-input>
          <el-input style="width: 40px;"  v-model="plans[index].view_contact_num" :disabled="setDisable(index)" :class="checkErr(index,'view_contact_num')? 'error' : ''"></el-input>
        </el-col>
        <el-col :span="4" style="text-align:center;border-right:1px solid #ddd;width:148px;" v-if="modifyAgent">
          <el-input style="width: 60px;" v-model="plans[index].gonghai_volume" :class="checkErr(index,'gonghai_volume')? 'error' : ''" @blur="checkVolume(item,index,'gonghai_volume')" :disabled="!canEdit"></el-input>
          <el-input style="width: 60px;"  v-model="plans[index].clue_volume" :class="checkErr(index,'clue_volume')? 'error' : ''" @blur="checkVolume(item,index,'clue_volume')" :disabled="!canEdit"></el-input>
        </el-col>
        <el-col :span="comColSpan(4,5)" style="text-align:center;border-right:1px solid #ddd;width:157px;">
          <el-input style="text-align:center;width:35%" v-model="plans[index].renewal" :disabled="(plans[index].renewal==1&&plans[index].unit==3)||setDisable(index)" :maxlength="4" :class="checkErr(index,'renewal')? 'error' : ''"></el-input>
          <el-select v-model="plans[index].unit" placeholder="年" style="width: 40%" @change="setLimit(index)" :disabled="setDisable(index)">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="2" style="text-align:center;border-right:1px solid #ddd;width:79px;">
          <el-input style="text-align:center;width:50px" v-model="plans[index].extraSubCount" :maxlength="5"  :disabled="!canEdit" :class="checkErr(index,'extraSubCount')? 'error' : ''"> </el-input>
        </el-col>
        <el-col :span="2" style="text-align:center;border-right:1px solid #ddd;width:79px;">
          <el-input style="text-align:center;width: 50px;" v-model="plans[index].extraExpiry" :maxlength="5" :disabled="!canEdit" :class="checkErr(index,'extraExpiry')? 'error' : ''"> </el-input>
        </el-col>
        <el-col :span="2" style="text-align:center;border-right:1px solid #ddd;width:79px;">
          <el-input style="text-align:center;width: 50px;" v-model="plans[index].viewQuota" :maxlength="5" :disabled="!canEdit" :class="checkErr(index,'viewQuota')? 'error' : ''"> </el-input>
        </el-col>
        <el-col :span="2" style="text-align:center;border-right:1px solid #ddd;width:79px;">
          <el-input style="text-align:center;width: 50px;" v-model="plans[index].price" :maxlength="5" :disabled="setDisable(index)" :class="checkErr(index,'price')? 'error' : ''"> </el-input>
        </el-col>
        <el-col :span="2" style="text-align:center;width:20px;">
          <i style="width:20px;margin-left:4px;color:#555;font-size: 18px;cursor:pointer;vertical-align: -2px;" @click="deletePlan(index)" class="el-icon-delete" :class="{'disabled-icon':setDisable(index)}"></i>
        </el-col>
      </el-row> -->
      <el-table :data="plans" border highlight-current-row header-row-class-name='table-header' style="width: 100%">
        <el-table-column style="text-align: center;" width="150px" align="center" label="套餐名称">
          <template slot-scope="{row,$index}">
            <el-input style="text-align:center;width:100%;" v-model="row.type"  :disabled="setDisable($index)" :class="checkErr($index,'type')? 'error' : ''"></el-input>
          </template>
        </el-table-column>
        <el-table-column style="text-align: center;" align="center" label="主/子/日查看额度">
          <template slot-scope="{row,$index}">
            <el-input style="width: 25%;" v-model="row.mainaccounts" :disabled="true"></el-input>
            <el-input style="width: 30%;" v-model="row.subaccounts" :disabled="setDisable($index)"  :class="checkErr($index,'subaccounts')? 'error' : ''"></el-input>
            <el-input style="width: 38%;"  v-model="row.view_contact_num" :disabled="setDisable($index)" :class="checkErr($index,'view_contact_num')? 'error' : ''"></el-input>
          </template>
        </el-table-column>
        <el-table-column style="text-align: center" align="center" width="100px" label="企业公海容量" v-if='modifyAgent'>
          <template slot-scope="{row,$index}">
            <el-input style="width: 60px;" v-model="row.gonghai_volume" :class="checkErr($index,'gonghai_volume')? 'error' : ''"  :disabled="!canEdit"></el-input>
          </template>
        </el-table-column>
        <el-table-column style="text-align: center" align="center" width="90px" label="线索容量" v-if='modifyAgent'>
          <template slot-scope="{row,$index}">
            <el-input style="width: 60px;"  v-model="row.clue_volume" :class="checkErr($index,'clue_volume')? 'error' : ''"  :disabled="!canEdit"></el-input>
          </template>
        </el-table-column>
        <el-table-column style="text-align: center" width="100px" align="center" label="默认有效期">
          <template slot-scope="{row,$index}">
            <el-input style="text-align:center;width:45%" v-model="row.renewal" :disabled="true" :maxlength="4" :class="checkErr($index,'renewal')? 'error' : ''"></el-input>
            <el-select v-model="row.unit" placeholder="年" style="width: 40%" @change="setLimit($index)" :disabled="setDisable($index)">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <!-- <el-table-column style="text-align: center" width="90px" align="center" label="最多加子">
          <template slot-scope="{row,$index}">
            <el-input style="text-align:center;width:100%;" v-model="row.extraSubCount" :maxlength="5"  :disabled="!canEdit" :class="checkErr($index,'extraSubCount')? 'error' : ''"> </el-input>
          </template>
        </el-table-column>
        <el-table-column style="text-align: center" width="90px" align="center" label="最多加月">
          <template slot-scope="{row,$index}">
            <el-input style="text-align:center;width: 100%;" v-model="row.extraExpiry" :maxlength="5" :disabled="!canEdit" :class="checkErr($index,'extraExpiry')? 'error' : ''"> </el-input>
          </template>
        </el-table-column>
        <el-table-column style="text-align: center" width="90px" align="center" label="加日查看">
          <template slot-scope="{row,$index}">
            <el-input style="text-align:center;width: 100%;" v-model="row.viewQuota" :maxlength="5" :disabled="!canEdit" :class="checkErr($index,'viewQuota')? 'error' : ''"> </el-input>
          </template>
        </el-table-column> -->
        <el-table-column style="text-align: center" width="70px" align="center" label="单价" v-if="source!=2">
          <template slot-scope="{row,$index}">
            <el-input style="text-align:center;width:100%;" v-model="row.price" :maxlength="5" :disabled="setDisable($index)" :class="checkErr($index,'price')? 'error' : ''"></el-input>
          </template>
        </el-table-column>
        <el-table-column :key="Math.random()" style="text-align: center" width="95px" align="center" label="新价格续费" v-if="source!=2">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.renew_type" :active-value="1" :inactive-value="0" active-color="#13ce66" inactive-color="#ccc" style="margin-left: 10px;" :disabled="setDisable(scope.$index)" @change="changeRenewType($event,scope.row,scope.$index)">
          </el-switch>
          <span class="meal-renew" :class="{'meal-renew-no':( scope.row.renew_type!='1' ) }">{{scope.row.renew_type=='1' ? '是' : '否'}}</span>
          </template>
        </el-table-column>
        <el-table-column style="text-align: center" width="70px" align="center" label="套餐状态">
          <template slot-scope="scope">
            <span class="meal-sell-status" :class="{'meal-sell':( scope.row.status=='1' ) }">{{scope.row.status=='1'?'售卖中':'已下架'}}</span>
          </template>
        </el-table-column>
        <el-table-column style="text-align: center" width="90px" align="center" label="用户统计" v-if="source!=2">
          <template slot-scope="scope">
            <p>未过期: {{ showMealUseStatics(scope.row.type, 0) }}</p>
            <p>已过期: {{ showMealUseStatics(scope.row.type, 1) }}</p>
          </template>
        </el-table-column>
        <el-table-column :key="Math.random()" width="110px" align="center" label="操作">
          <template slot-scope="scope">
            <el-button v-if="showMealHandleButton(scope.$index)" class="meal-button" :class="scope.row.status=='1'?'meal-button-show' : 'meal-button-off'" @click="mealStatus(scope.$index,scope.row)">{{scope.row.status=='1'?'下架':'上架'}}</el-button>
            <i style="width:20px;margin-left:4px;color:#555;font-size: 18px;cursor:pointer;vertical-align: -2px;" @click="deletePlan(scope.$index)" class="el-icon-delete" :class="{'disabled-icon':setDisable(scope.$index)}"></i>
          </template>
        </el-table-column>
      </el-table>
      <el-row :gutter="10" v-if="role!='admin'" style="border-bottom:1px solid #e5e5e5; ">
        <el-col :span="3">
          <div class="plus" @click="addPlan" :class="{'disabled':( !canEdit && role!='root' && role != 'admin' ) }">
            +
          </div>
        </el-col>
      </el-row>
      <div class="addService" id="mealAddInput" v-if="role=='root'">
        <div class="service-types" style="margin-bottom: 20px">通话外呼:
          <el-switch v-model="extra.enableCall" active-color="#13ce66" inactive-color="#ccc" style="margin-left: 10px;" :disabled="!canEdit">
          </el-switch>
        </div>
        <el-input class="customText" v-model="extra.callApplyCustomText" placeholder="请输入修改后的文案" ></el-input>
        <br/>
        <div class="service-types" style="margin-bottom: 20px;margin-left: 10px;" v-if="source!=2">
          <span style="display:inline-block;width:60px;">流量包:</span>
          <el-switch v-model="flow_packet_enable" active-color="#13ce66" inactive-color="#ccc" style="margin-left: 10px;" :disabled="!canEdit">
          </el-switch>
        </div>
        <div class="flow-group" v-if="source!=2">
          <span class="flow-input">{{flow_packet.flow_packet_price}}</span>
          <span>
          元
          </span>
          （规格：1000条/1年）
        </div>
        <br />
        <div class="service-types" style="margin-bottom: 20px;margin-left: 10px;">任务中心:
          <el-switch v-model="extra.enableTask" active-color="#13ce66" inactive-color="#ccc" style="margin-left: 10px;" :disabled="!canEdit">
          </el-switch>
        </div>
        <el-button class="button" v-show="extra.enableTask" type="primary" @click="addTask">增加任务额度选项</el-button>
        <el-row class="speTable" style="color:#555" type="flex" :gutter="10"  v-show="extra.enableTask&&taskListConfig.length>0">
          <el-col :span='12'  class="title">任务额度设置（条/天）</el-col>
          <el-col :span='12'  class="title">单价（X条任务额度/Y元/年）</el-col>
          <el-col :span='12' class="title" style="border-left:none;">操作</el-col>
        </el-row>
        <el-row v-show="extra.enableTask"  @click.native="clearTask" v-for="(item, index) in taskListConfig" :key="index" :gutter="10" class="meal-content speTable">
          <el-col :span="12" style="border-right:1px solid #ddd;">
            <el-input style="text-align:center" v-model="item.task_num"
                      placeholder="设置额度" :class="checkTaskErr(index, 'task_num')? 'error' : ''"  oninput="value=value.replace( /[^\d]/g, '' )" :maxlength="5"></el-input>
          </el-col>
          <el-col :span="12" style="border-right:1px solid #ddd;">
            <el-input style="text-align:center" v-model="item.task_price"
                      placeholder="单价" :class="checkTaskErr(index, 'task_price')? 'error' : ''" :maxlength="5"></el-input>
          </el-col>
          <el-col :span="12" style="text-align:center">
            <i style="width:20px;margin-left:4px;color:#555;font-size: 18px;cursor:pointer;vertical-align: -2px;" @click="deleteTask(index)" class="el-icon-delete" :class="{'disabled-icon':!canEdit}"></i>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 更改显示样式结构 -->
    <slot></slot>
    <div class="plan-content" v-if="pluginsList&&pluginsList.length>0 && role=='root'"  :class="{'spe-content2':modifyAgent}">
      <div class="new-title">集成系统</div>
      <div class="addService">
        <div class="service-types pluginItem" v-for="item in pluginsList"  :class="[checkPlugin(item._id)?'active':'', !modifyAgent?'main-edit':'']" @click="modifyAgent?choosePlugin(item):openAddSytem('edit',item)">
          <img src="../../assets/images/task/plugin1.png">
          <span>{{item.name}}</span>
          <span class="deleteRobot el-icon-delete"  v-if="!modifyAgent" @click.stop="deleteRobot(item)"></span>
        </div>
        <div class="plus add-plus-system" @click="openAddSytem"  v-if="!modifyAgent">
          +
        </div>
      </div>
    </div>
    <!-- 新增添加机器人 -->
    <add-export-system v-if="!modifyAgent" ref="editSystems" :plugin='pluginsList' :delSystemVisible='delSystemVisible' :editRow='editRow'
                        :dialogVisible='dialogVisible'
                        @hideDialog='hideDialog'
                        @successAddSystem='successAddSystem'
                        @hideDelDialog='hideDelDialog'
                        @successDelSysten='successDelSysten'></add-export-system>
    <HistoryUnitPrices v-if="isShowHistoryDialog" :historyUnitPrices="historyUnitPrices" :isShowHistoryDialog="isShowHistoryDialog" @onChangeHistory="onChangeHistory"></HistoryUnitPrices>
  </div>
</template>
<script>
import { isEmpty } from '../../common/utils';
  import addExportSystem from '../user/addExportSystem.vue'
  import HistoryUnitPrices from './historyUnitPrices.vue'
  export default {
    name: 'mealEditor',
    props: [
      'value',
      'canEdit',
      'extra',
      'bigWrapper',
      'plugin',
      'modifyAgent',
      'choosedPlugin',
      'unitPrice',
      'historyUnitPrices',
      'source', 
      'flow_packet',
      'userId'
    ],
    components:{addExportSystem,HistoryUnitPrices},
    data() {
      const blurText = async(rule, value, callback) => {
        const isAddFirst = new RegExp(/[+.].*/).test(value) //过滤掉以加号开头情况
        const boolean = new RegExp('^[0-9][0-9]*$').test(Number(value))
        if (!boolean || isAddFirst) {
          callback(new Error("仅支持输入0和正整数"));
        }
      }
      return {
        plans: [
          {
            type: '',
            mainaccounts: '',
            subaccounts: '',
            view_contact_num: '',
            renewal: '',
            unit:'',
            extraSubCount:'',
            extraExpiry:'',
            viewQuota:'',
            gonghai_volume:2000,
            clue_volume:5000,
            price : 0,
            renew_type : 1, // 1=新价格续费(默认) 0=不使用新价格
            status : 1, // 套餐状态(1=上架，0=下架)
          }
        ],
        errorIndexs: [],
        errDetail:[],
        step:'',
        options: [{
          value: 3,
          label: '年'
        }, {
          value: 2,
          label: '月'
        }, {
          value: 1,
          label: '日'
        }],
        addSubAccount:0,
        addRenewal:0,
        units:['','日','月','年'],
        typeList:[],

        taskList:[],
        taskErrIndexs:[],
        delSystemVisible:false,//删除集成系统
        dialogVisible:false,//添加集成系统弹窗
        editRow:{},//编辑机器人
        pluginsList:[],//集成系统列表信息
        outVolume:0,//超出限额提示 ,0 一般套餐提示，1 输入正整数提示 2 超额50000提示

        ruleForm:{
          newUnitPrice:0,  //单价
        },
        rules:{
          newUnitPrice:[
            { required: true, message: '请输入必填项', trigger: ['blur', 'change']},
            { validator: blurText, trigger: ['blur']}
          ]
        },
        isShowHistoryDialog:false,
        planIndexList : {}, // 新增套餐
        taskListConfig : [], // 任务额度配置
        taskErrDetail : [], // 任务额度配置错误信息
        mealUseStatics : {}, // 套餐使用情况统计
        mealToDel : 0, // 是否可删除套餐 
      };
    },
    watch: {
      value: {
        handler: function(val) {
         
          for( let i = 0; i < val.length; i ++ )
          {
            if( !val[ i ].hasOwnProperty( 'price' ) ) {
              val[ i ][ 'price' ] = 0; // 兼容历史没有价格的数据
            }
            if( !val[ i ].hasOwnProperty( 'renew_type' ) ) {
              val[ i ][ 'renew_type' ] = 1; // 兼容历史没有续费类型的数据(默认开启)
            }
            if( !val[ i ].hasOwnProperty( 'status' ) ) {
              val[ i ][ 'status' ] = 1; // 兼容历史没有套餐状态的数据(默认上架)
            }
          }
          this.plans = val;
          this.typeList = [];
          val.forEach(e=>{
            this.typeList.push(e.type)
          });
        },
        immediate: true
      },
      plans: {
        handler: function(val) {
          this.$emit('input', val);
        },
        deep: true
      },
      extra: {
        handler: function(val) {
          this.taskList = val.taskQuotaAvailable||[];
        },
        deep: true
      },
      taskList: {
        handler: function(val,oldVal) {
          let data = Object.assign({},this.extra,{taskQuotaAvailable:val});
          this.$emit('taskChange', data);
        },
        deep: true
      },
      taskListConfig : {
        handler: function(val,oldVal) {
          let newTaskList = [];
          for( let i = 0; i < val.length; i ++ ) {
            newTaskList.push( val[ i ].task_num );
          }
          let data = Object.assign({},this.extra,{taskQuotaConfig:val, taskQuotaAvailable: newTaskList });
          this.$emit('taskChange', data);
        },
        deep: true
      },
      unitPrice:{
        handler:function(val){
          this.ruleForm.newUnitPrice = val
        },
        immediate: true
      },
    },
    created(){
      if(this.extra ){
        if( this.extra.taskQuotaAvailable && this.extra.taskQuotaAvailable.length>0 ) {
          this.taskList = this.extra.taskQuotaAvailable;
        }
        if( ( 'taskQuotaConfig' in this.extra ) && this.extra.taskQuotaConfig.length > 0 ) {
          this.taskListConfig = this.extra.taskQuotaConfig;
        } else if( this.taskList.length > 0 ) {
          // 使用原数据处理
          for( let i = 0; i < this.taskList.length; i ++ ) {
            this.taskListConfig.push( {
              'task_num' : this.taskList[ i ],
              'task_price' : 0
            } )
          }
        }
      }
      if( this.role == 'root' )
      {
        this.getPluginList();
      }
      if( this.userId ) {
        this.getMealUseStaticsData();
      }
    },
    computed: {
      flow_packet_enable: {
        get () {
          const _self = this;
          return Boolean(this.flow_packet.flow_packet_enable)
        },
        set (val) {
          this.flow_packet.flow_packet_enable = val;
        }
      }
    },
    methods: {
      isNumber( val ) {
        console.log( 'isNumber==', val );
        val = val.replace( /[^\d]/gi, "" )
        return val;
      },
      addPlan() {
        if( this.canEdit || this.role == 'root' || this.role == 'admin' ){
          this.plans.push({
            type: '',
            mainaccounts: '1',
            subaccounts: '',
            view_contact_num: '',
            renewal: 1,
            unit:3,
            extraSubCount:0,
            extraExpiry:0,
            viewQuota:0,
            gonghai_volume:2000,
            clue_volume:5000,
            price:0,
            renew_type:1,
            status : 1,
          });
          this.planIndexList[ this.plans.length - 1 ] = 1;
        }
      },
      deletePlan(index) {
        if(this.canEdit || this.role == 'root' ){
          if (this.plans.length === 1) {
            this.$message.error('请至少保留一个套餐类型');
            return;
          }
          if( this.role != 'root' && !( index in this.planIndexList ) ) {
            return;
          }
          if( this.plans.length > index ) {
            if( index in this.planIndexList ) {
              delete this.planIndexList[ index ];
              this.plans.splice(index, 1);
              return;
            }
            if( this.mealToDel != 0 ) {
              let m = this.plans[ index ];
              if( this.mealUseStaticsCountByName( m.type || '' ) < 1 ) {
                delete this.planIndexList[ index ];
                this.plans.splice(index, 1);
                return;
              } 
              this.$message.error('不可删除');
              return;
            }
            this.$message.error('稍后操作');
          }
        }
      },
      clear() {
        this.errorIndexs = [];
        this.errDetail = [];
      },
      validatePlan(plan,index) {
        this.errDetail[index] =[];
        for (let key in plan) {
          if (key == 'type' && (!plan[key]||(this.typeList.indexOf(plan[key])!= index)&&this.typeList.indexOf(plan[key])!= -1)){
            this.errDetail[index].push(key);
          }else{
            if(typeof plan[key] =='string'){
              plan[key] = plan[key].trim();
            }
          }
          if ('mainaccounts subaccounts view_contact_num renewal extraSubCount extraExpiry viewQuota gonghai_volume clue_volume price'.indexOf(key) != -1 && ((!plan[key] && plan[key] != '0') || !/^\d+$/.test(plan[key]))) {
            this.errDetail[index].push(key);
            this.outVolume = 3;
          }
          if ('mainaccounts subaccounts view_contact_num renewal extraSubCount extraExpiry viewQuota gonghai_volume clue_volume price'.indexOf(key) != -1 && /^\d+$/.test(plan[key])) {
            plan[key] = parseInt(plan[key]);
          }
          if (key == 'subaccounts' && plan[key] > 30) {
            this.errDetail[index].push(key);
            if( this.role != 'root' ) {
              this.outVolume = 3;
            }
          }
          if ( this.role!='root' && key == 'view_contact_num' && plan[key] > 10000 && ( index in this.planIndexList ) ) {
            // 如果admin，是新增数据才需要检查，历史存在数据不检查，因为root账户创建的可能超过10000
            this.errDetail[index].push(key);
            this.outVolume = 3;
          }
          if(key=='unit'){
            if(plan[key]== 2 && (plan.renewal)>12|| !plan.renewal||plan.renewal=='0'){
                this.errDetail[index].push('renewal');
            }
            if(plan[key]==1 && (plan.renewal)>30|| !plan.renewal||plan.renewal=='0'){
              this.errDetail[index].push('renewal');
            }
          }
          if(key=='extraSubCount'){
            if( plan[key]>20||(plan[key]!='0'&&!plan[key])){this.errDetail[index].push(key);}
          }
          if(key=='extraExpiry'){
            if(plan[key]>36||(plan[key]!='0'&&!plan[key])){this.errDetail[index].push(key);}
          }
          if(key=='viewQuota'){
            if(plan[key]>50000||(plan[key]!='0'&&!plan[key])){this.errDetail[index].push(key);}
          }
          if(key=='gonghai_volume' || key=='clue_volume'){
            let reg = /^[0-9]*[1-9][0-9]*$/;
            if(!reg.test(Number(plan[key]))){
              this.errDetail[index].push(key);
              this.outVolume = 1;
            }
            if(plan[key]>50000||(plan[key]!='0'&&!plan[key])){
              this.errDetail[index].push(key);
              this.outVolume = 2;
            }
          }
          if( key == 'price' && parseInt( plan[ key ] + '' ) < 0 ) {
            this.errDetail[index].push(key);
            this.outVolume = 3;
          }
        }
      },
      validatePlans() {
        this.errDetail= [];
        let flag = true;
        this.errorIndexs = [];
        for (let i = 0; i < this.plans.length; i++) {
          this.validatePlan(this.plans[i],i)
          if(this.errDetail){
            this.errDetail.forEach((e,i)=>{
               if(e.length>0){
                 flag = false;
                 this.errorIndexs.push(i);
               }
            });
          }
        }
        if (this.errorIndexs.length > 0) {
          // console.log( this.errorIndexs,this.errDetail)
          this.$message.error(this.outVolume==2?'已达上限50000':(this.outVolume==1?'请输入正整数':'请填写有效的套餐组合'));
        }
        return flag;
      },
      setLimit(index){
        switch(this.plans[index].unit){
          case 1:
            this.plans[index].renewal = 10;break;
          case 2:
            this.plans[index].renewal = 12;break;
          case 3:
            this.plans[index].renewal = 1;break;
          default:break;
        }
      },
      reset() {
        this.errorIndexs= [];
        this.errDetail= [];
      },
      checkErr(index,key){
        if(this.errDetail[index]){
          if(this.errDetail[index].indexOf(key)!=-1){
              return true;
          }
        }
      },
      // 公海线索
      checkVolume(item,index,key){
          // if(!/^[1-9]\d+$/.test(item[key]) || !item[key]){
          //   this.$message.error('请输入正整数')
          // }
          // if(item[key]>50000){
          //   this.$message.error('已达上限50000');
          // }
          // this.validatePlan(item,index);
          
      },
      //任务额度
      addTask() {
        if(this.taskList.length<10){
          //this.taskList.push('');
          this.taskListConfig.push( { 'task_num' : 0, 'task_price' : 0 } );
        }else{
          this.$message.error('最多设置十个任务额度选项');
        }
      },
      deleteTask(index) {
        //this.taskList.splice(index, 1);
        this.taskListConfig.splice( index, 1 );
      },
      validateTaskList() {
        let flag = true, overLimint = false, notAllow = 0, notExists = false;
        this.taskErrIndexs =[];
        this.taskErrDetail = [];
        let numExists = [];
        for (let i = 0; i < this.taskListConfig.length; i++) {
          this.taskErrDetail[ i ] = [];
          let data =  this.taskListConfig[i];
          let taskNum = data.task_num;
          let taskPrice = data.task_price;
          if(typeof taskNum =='string'){
            taskNum = taskNum.trim();
          }
          if(typeof taskPrice =='string'){
            taskPrice = taskPrice.trim();
          }
          if(/^\d+$/.test(taskNum)){
            taskNum = parseInt(taskNum);
          }
          if(/^\d+$/.test(taskPrice)){
            taskPrice = parseInt(taskPrice);
          }
          let taskNumKey = taskNum + '';
          if( taskNumKey in numExists ) {
            flag = false;
            notExists = true;
            this.taskErrIndexs.push( i );
            this.taskErrDetail[ i ].push( 'task_num' );
          }
          numExists[ taskNumKey ] = 1;
          if(isNaN(taskNum) || isEmpty( taskNum ) ){
            flag = false;
            notAllow = 1;
            this.taskErrIndexs.push(i);
            this.taskErrDetail[ i ].push( 'task_num' );
          } else if(taskNum>50000 || taskNum<=0){
            overLimint = taskNum>50000;
            flag = false;
            this.taskErrIndexs.push( i );
            this.taskErrDetail[ i ].push( 'task_num' );
          }
          if(isNaN(taskPrice) || isEmpty( taskPrice ) || !/^\d+$/.test(taskPrice)){
            flag = false;
            notAllow = 3;
            this.taskErrIndexs.push(i);
            this.taskErrDetail[ i ].push( 'task_price' );
          } else if(taskPrice<0 || taskPrice>=100000 ){
            flag = false;
            notAllow = taskPrice>=100000 ? 2 : 1;
            this.taskErrIndexs.push( i );
            this.taskErrDetail[ i ].push( 'task_price' );
          }
        }
        if (this.taskErrIndexs.length > 0) {
          if( notExists ) {
            this.$message.error( '任务额度不可重复' );
          } else {
            this.$message.error(overLimint?'任务额度设置最大值不超过50000': (notAllow == 1 || notAllow == 3 ? ( notAllow == 1 ? '请输入正整数' : '仅支持正整数和0' ): ( notAllow == 2 ? '任务额度单价不能大于99999' : '请设置额度' ) ));
          }
        }
        return flag;
      },
      checkTaskErr(index,key){
        // if(this.taskErrIndexs.indexOf(index)!==-1){
        //   return true;
        // }
        if( this.taskErrDetail[ index ] ){
          if(this.taskErrDetail[index].indexOf(key)!=-1){
              return true;
          }
        }
      },
      taskQuotaCheck( index, key ) {

        this.taskErrDetail = [];
        this.taskErrDetail[ index ] = [];
        let len = this.taskListConfig.length;
        if( index < len && !isEmpty( this.taskListConfig[ index ] ) ) {
          let data = this.taskListConfig[ index ];
          let num = key == 'task_num' ? data.task_num : data.task_price;
          if(typeof num =='string'){
            num = num.trim();
          }
          if(/^\d+$/.test(num)){
            num = parseInt(num);
          }
          if( isEmpty( num ) ) {
            this.taskErrDetail[ index ].push( key );
          } else if( key == 'task_num' && ( num > 50000 || num<=0 ) ) {
            this.taskErrDetail[ index ].push( key );
          } else if( key == 'task_price' && ( num > 99999 || num<0 ) ) { 
            this.taskErrDetail[ index ].push( key );
          }
        }
      },
      clearTask() {
        this.taskErrIndexs =[];
        this.taskErrDetail = [];
      },
      //集成系统
      checkPlugin(value){
        if(this.choosedPlugin.indexOf(value)!=-1){
          return true;
        }else{
          return false;
        }
        // if(this.choosedPlugin.length==0){return false}
        // let plugins =this.choosedPlugin.map((item)=>{
        //   return item._id
        // });

        // if(plugins.indexOf(value)!=-1){
        //   return true
        // }else{
        //   return false
        // }
      },
      choosePlugin(_item){
        let value = _item._id
        let choosedNow = this.cloneDeep(this.choosedPlugin);
        // let choosedNow = choosedNowPlusgins.map((item)=>{
        //       return item._id
        //     })
        if(choosedNow.indexOf(value)!=-1){
          let index = '';
          choosedNow.forEach((item,i)=>{
            if(item===value){
              index = i;
            }
          });
          choosedNow.splice(index, 1);
        }else{
          choosedNow.push(value);
        }
        // console.log(choosedNow,'===========')
        this.$emit('choosePlugin', choosedNow);
      },
      // 分销选中集成系统
      selectSystem(item){
        // 选中与反选，传值后端

      },
      hideDialog(){
        this.dialogVisible = !this.dialogVisible;
      },
      // 添加集成系统成功
      successAddSystem(){
        this.dialogVisible = false;
        this.getPluginList();
      },
      openAddSytem(type,item){
        if(type=='edit'){
          // 传入item
          this.editRow = item;
          this.$refs.editSystems.initForm(false,item);
        }else{
          this.editRow = {};
          this.$refs.editSystems.initForm()
        }
        this.dialogVisible = !this.dialogVisible;
        this.delSystemVisible = false;
      },
      hideDelDialog(){
        this.delSystemVisible = false;
      },
      // 删除集成系统
      deleteRobot(item){
        // if(!this.canEdit){return}
        // 如果有绑定关系，无法删除，并提示无法删除，已绑定分销
        // this.dialogVisible = false;
        this.delSystemVisible = !this.delSystemVisible;
        this.editRow = item;
        
      },
      async successDelSysten(){
        this.hideDelDialog();
        this.getPluginList();
      },
      async getPluginList(){
        // 获取集成系统列表
        this.pluginsList = await this.apiData('get', 'user/config/listPlugins');
      },
      // 宽度的计算
      comColSpan(num1,num2){
        return this.modifyAgent?num1:num2
      },
      // 父组件回调拿数据
      callBackRuleForm(){
        return this.ruleForm
      },

      onChangeHistory(){
        this.isShowHistoryDialog = false
      },
      setDisable( index ) {

        if( this.role == 'root' ) {
          return !this.canEdit;
        }
        return !this.canEdit && !( index in this.planIndexList );
      },
      changeRenewType( e, row, index ) {
        row.renew_type = parseInt( row.renew_type ) == 1 ? 1 : 0;
        this.$set( this.plans, index, row );  // 必须重新赋值，否则绑定的数据不生效
      },
      mealStatus( index, row ) {
        if(this.canEdit || this.role == 'root' ){
          row.status = parseInt( row.status ) == 1 ? 0 : 1; 
          this.plans[ index ] = row;
          this.$set( this.plans, index, row );
        }
      },
      async getMealUseStaticsData(){
        // 获取集成系统列表
        const data = await this.apiData('post', 'user/mealUseStatics', { 'user_id' : this.userId });
        if( data ) {
          this.mealUseStatics = data;
        }
        this.mealToDel = 1;
      },
      showMealUseStatics( name, type = 0 ) {
        let count = 0;
        if( !isEmpty( this.mealUseStatics ) && !isEmpty( name ) && ( name in this.mealUseStatics ) ) {
          count = type == 0 ? ( this.mealUseStatics[ name ][ 'normal' ] || 0 )  : ( this.mealUseStatics[ name ][ 'out' ] || 0 );
        }
        return count;
      },
      showMealHandleButton( index ) {
        if( index in this.planIndexList ) {
          return false;
        }
        return this.source!=2;
      },
      mealUseStaticsCountByName( name ) {
        let count = 0;
        if( !isEmpty( this.mealUseStatics ) && !isEmpty( name ) && ( name in this.mealUseStatics ) ) {
          count = parseInt( this.mealUseStatics[ name ][ 'normal' ] || 0 ) + parseInt( this.mealUseStatics[ name ][ 'out' ] || 0 );
        }
        return count;
      }
  },
  };
</script>
<style lang="scss" scoped>
  @import '../../../static/css/searchInput.css';
  .plan-content {
    width:980px;
    background: #ffffff;
    i:hover {
      color: #f56c6c;
    }
    &.spe-content{
      width:1040px;
    }
  }
  .title{
    background: #f5f8fa;
    font-size: 14px;
    text-align: center;
    border: 1px solid #ddd;
    height: 40px;
    line-height: 40px;
    color:#909399;
    font-weight: bold;
  }
  .meal-content{
    border-bottom:1px solid #ddd;
    border-left:1px solid #ddd;
    border-right:1px solid #ddd;
    height: 46px;
    line-height: 46px;
  }
  .middle-content{
    text-align:center;
    border-right:1px solid #ddd;
    input{
      text-align: center;
    }
  }

  .plus {
    border: 1px solid #41bfbf;
    color: #41bfbf;
    text-align: center;
    height: 28px;
    border-radius: 4px;
    line-height: 24px;
    font-size: 26px;
    cursor: pointer;
    margin:10px 0 ;
    width: 50px;
    &:hover {
      background: #f9ffff;
      border: 1px solid #38a6a6;
    }
  }
  .plus.disabled {
    border: 1px solid #e8e8e8;
    color: #999;
    background: #f5f5f5;
    cursor: not-allowed;
    &:hover {
      background: #f5f5f5;
      border: 1px solid #e8e8e8;
    }
  }
  i.disabled-icon{
    color:#ddd !important;
    cursor: not-allowed !important;
  }
  .new-title {
    font-size: 20px;
    font-weight:500;
    text-align: center;
    position: relative;
    margin: 20px auto;
    width: 100px;
    &:after {
      content: '';
      display: inline-block;
      width: 45px;
      height: 2px;
      background: #41bfbf;
      position: absolute;
      top: 26px;
      left: 50%;
      transform: translate(-50%);
    }
  }
  .addService{
    margin:20px auto 0;
    font-size: 14px;
    br,.button,.speTable,.customText{
      display: none;
    }
    .add-plus-system{
      display: inline-block;
      margin: 0;
      vertical-align: middle;
      margin-bottom: 15px;
    }
    .service-types{
      width: 150px;
      height: 40px;
      line-height: 40px;
      display: inline-block;
      border: 1px solid #e8e8e8;
      padding: 0 10px;
      border-radius: 2px;
    }
    .service-types.active{
      border: 1px solid #41bfbf;
      background: #fff;
    }
    .pluginItem{
      margin-bottom: 30px;
      margin-right: 15px;
      width: 180px;
      text-align: center;
      position: relative;
      /*cursor: pointer;*/
      img{
        position: relative;
        top:4px;
        left:0;
      }
      span{
        margin-left:10px;
        vertical-align:5px;
      }
      .deleteRobot{
        position: absolute;
        top: 6px;
        right: 6px;
        &:hover{
          cursor: pointer;
          color: #EC647A;
        }
        
      }
      &.main-edit{
        .deleteRobot{
          display: none;
          // &.disabled{
          //   color: #ddd;
          //   &:hover{
          //     cursor: not-allowed;
          //     color: #ddd;
          //   }
          // }
        }
        &:hover{
          .deleteRobot{
            display: block;
          }
        }
        
      }
      &:hover{
        cursor: pointer;
      }
    }
  }

  .spe-content{
    .new-title{
      opacity: 0;
      margin: 5px auto;
    }
    .addService{
      br,.button{
        display: inline;
      }
      .speTable{
        display: flex;
      }

      .customText{
        display: inline-block;
      }
      .service-types{
        margin-left: 0 !important;
        margin-right: 20px;
      }
    }
  }
  .spe-content2{
    .new-title {
      margin: 20px 0;
      &:after {
        display: none;
      }
    }
  }
  .plan-footer {
    text-align: right;
    background: #ffffff;
    margin-top:30px;
  }
  .button1,.button2{
    width: 84px;
    height:36px;
    text-align: center;
    line-height: 36px;
    color:#fff;
    cursor: pointer;
    display: inline-block;
    font-size: 14px;
  }
  .button1{
    background: #c6cbd0;
    margin-right: -5px;
  }
  .button1:hover{
    background: #b3b8bd;
  }
  .button2{
    background: #41bfbf;
    margin-right: -28px;
  }
  .button2:hover{
    background: #3db3b3;
  }

  #mealInput{
    .unit-price{
      width: 300px;
      display: flex;
      height: 68px;
      align-items: center;
      span{
        display: inline-block;
        height: 48px;
        line-height: 48px;
      }
      img{
        margin: 0 4px;
        cursor: pointer;
      }
      .history-title{
        margin-left: 20px;
        color: #41bfbf;
        cursor: pointer;
      }
      .not-click-title{
        color: #d3dce6;
        margin-left: 20px;
      }
    }
  }
  .meal-button {
    width: 60px;
    height:35px;
    font-size: 12px;
    text-align: center;
  }
  .meal-button-off {
    background: #ff9933 !important;
    &:hover {
      cursor: pointer;
      background: #ff9933 !important;
    }
  }
  .meal-button-show {
    background: #A9A9A9 !important;
    &:hover {
      cursor: pointer;
      background: #A9A9A9 !important;
    }
  }
  .meal-sell-status {
    font-size: 13px;
  }
  .meal-sell {
    color: green;
  }
  .meal-renew {
    font-size: 13px;
  }
  .meal-renew-no {
    color : red;
  }
</style>
<style lang="scss">
  .unit-price .el-input{
    width: 80px !important;
    height: 38px !important;
    .el-input__inner{
      text-align: center;
    }
  }
  .unit-price .el-form-item{
    margin-bottom: 0;
  }
  .unit-price{
    .el-form-item.is-error .el-input__inner{
      border-color: #F56C6C !important;
    }
    .el-form-item__error{
      top: 82%;
      white-space: nowrap;
    }
  }
  .data-list-box{
    .el-table th.el-table__cell{
      background: #fafafa;
      .cell{
        text-align: center;
      }
    }
    .el-table td.el-table__cell{
      .cell{
        text-align: center;
      }
    }
  }
  .pagination-box{
    margin-top: 24px;
    // margin-bottom: 32px;
    .el-pagination{
      padding: 0;
    }
  }
  .flow-group{
    display: inline-block;
    >span{
      margin: 0 10px 0 20px;
    }
  }
  .flow-input {
    cursor: not-allowed;
    border: 1px solid #e8e8e8;
    padding: 5px 10px;
    display: inline-block;
    border-radius:2px;
    margin-right:0px!important;
  }
</style>




// WEBPACK FOOTER //
// src/components/global/mealEditor.vue